import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import EquipmentForm from "../component/equipmentform";
import { dash } from "./displayValue";
import "../component/css/listing-table.css";

// Renders one <tr>. The parent owns the <table>, <colgroup> and <thead>.
function Equipment_table(props) {
  const navigate = useNavigate();
  const [showInquiryModal, setShowInquiryModal] = useState(false);

  const handleDetailsClick = () => {
    navigate("/productDetails", { state: { equipmentData: props } });
    window.parent.postMessage({ messageType: "scrolltop", data: 0 }, "*");
  };

  const handleInquireButtonClick = () => setShowInquiryModal(true);
  const handleCloseInquiryModal = () => setShowInquiryModal(false);

  const values = {
    jad_id: props.jad_id,
    description: props.description,
    model: props.model,
    vintage: props.vintage,
    Inspection_Available: props.Inspection_Available,
    Condition: props.Condition,
    Manufacturer: props.Manufacturer,
    thumb: props.thumb,
  };

  return (
    <tr>
      <td className="cell-thumb">
        {props.thumb ? (
          <img src={props.thumb} alt={`${props.jad_id || "Equipment"} thumbnail`} />
        ) : (
          // Keep the column's width even with no image so rows stay aligned.
          <div className="thumb-empty" />
        )}
      </td>
      <td>
        <div className="cell-id">{dash(props.jad_id)}</div>
        <div>{dash(props.description)}</div>
        {props.File ? (
          <a
            className="cell-spec"
            href={props.File}
            target="_blank"
            rel="noopener noreferrer"
          >
            Detailed Specifications
          </a>
        ) : null}
      </td>
      <td>{dash(props.model)}</td>
      <td>{dash(props.vintage)}</td>
      <td>{props.Inspection_Available === 0 ? "No" : dash(props.Inspection_Available)}</td>
      <td>{dash(props.Condition)}</td>
      <td>{dash(props.Manufacturer)}</td>
      <td className="cell-actions">
        <div className="listing-actions">
          <button className="more-details-btn" onClick={handleDetailsClick}>
            MORE DETAILS
          </button>
          <button className="inquire-btn" onClick={handleInquireButtonClick}>
            INQUIRE
          </button>
        </div>
        <EquipmentForm
          showInquiryModal={showInquiryModal}
          handleCloseInquiryModal={handleCloseInquiryModal}
          values={values}
          producttype="equipment"
        />
      </td>
    </tr>
  );
}

export default Equipment_table;
